import { MdOutlineComment } from 'react-icons/md';

type TripCommentProps = {
  comment: string | null;
};

export const TripComment = ({ comment }: TripCommentProps) => {
  if (!comment) return null;

  return (
    <div className="w-full flex gap-2">
      <div className="shrink-0">
        <MdOutlineComment size={18} />
      </div>
      <span className="grow text-s-r text-base-10 wrap-break-word">{`"${comment}"`}</span>
    </div>
  );
};
